/* eslint-disable react-hooks/rules-of-hooks */
import Link from 'next/link'
import styled from '@emotion/styled'
import { ButtonBase, CircularProgress, ButtonProps as MuiButtonProps } from '@mui/material'
import { alphaColorPallete } from 'src/components/button/palettes'
import { Colors, Shadows, Shapes, Typographies, useTypography } from 'src/components/theme'

type ButtonProps = MuiButtonProps & {
  elevation?: boolean
  loading?: boolean
}

export const ButtonSolid = (props: ButtonProps) => {
  const { startIcon, children, loading, ...rest } = props
  return (
    <BtnSolid {...rest}>
      {startIcon && !loading && <span className="start-icon">{startIcon as React.ReactNode}</span>}
      {loading && <CircularProgress size={18} color="inherit" />}
      {children}
    </BtnSolid>
  )
}

const BtnSolid = styled(ButtonBase)<ButtonProps>`
  display: flex;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
  padding: ${Shapes.spacing[2]}px ${Shapes.spacing[5]}px;
  background-color: ${(props) => alphaColorPallete[props.color ?? 'inherit'].dark};
  border: 1px solid transparent;
  border-radius: ${Shapes.borderRadius}px;
  color: ${Colors.textWhite};
  text-align: left;
  ${useTypography(Typographies.title2l)}
  box-shadow: ${(props) => (props.elevation ? Shadows.shadowLight : 'none')};
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) => alphaColorPallete[props.color ?? 'inherit'].extraDark};
    box-shadow: ${(props) => (props.elevation ? Shadows.shadowMedium : 'none')};
  }
  &:active {
    background-color: ${(props) => alphaColorPallete[props.color ?? 'inherit'].extraDark};
    box-shadow: ${(props) => (props.elevation ? Shadows.shadowDark : 'none')};
  }

  &:disabled {
    opacity: 0.4;
    box-shadow: none;
    cursor: not-allowed;
    pointer-events: none;
  }

  & > span.start-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Colors.bgWhite};
    height: 18px;
    min-height: 18px;
    width: 18px;
    min-width: 18px;
    padding: 4px;
    border-radius: 50%;
    svg {
      color: ${(props) => alphaColorPallete[props.color ?? 'inherit'].dark};
    }
  }
`

export const LinkSolid = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
  padding: ${Shapes.spacing[2]}px ${Shapes.spacing[5]}px;
  background-color: ${(props) => props.color || alphaColorPallete['inherit'].dark};
  border-radius: ${Shapes.borderRadius}px;
  color: ${Colors.textWhite};
  ${useTypography(Typographies.title2l)}
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) => props.color || alphaColorPallete['inherit'].dark};
  }
  &:active {
    background-color: ${(props) => props.color || alphaColorPallete['inherit'].dark};
  }

  &:disabled {
    opacity: 0.4;
    box-shadow: none;
    cursor: not-allowed;
    pointer-events: none;
  }

  & > span.start-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Colors.bgWhite};
    height: 18px;
    width: 18px;
    padding: 4px;
    border-radius: 50%;
    svg {
      color: ${Colors.textWhite};
    }
  }
`
